<div [@routerTransition] class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="page d-flex flex-row flex-column-fluid">
        <!--begin::Wrapper-->
        <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
            <!--begin::Header-->
            <div
                id="kt_header"
                ktHeader
                #ktHeader
                class="header align-items-stretch"
                data-kt-sticky="true"
                data-kt-sticky-name="header"
                data-kt-sticky-offset="{default: '200px', lg: '300px'}"
            >
                <!--begin::Container-->
                <div [class]="containerClass + '  d-flex align-items-center'">
                    <!--begin::Heaeder menu toggle-->
                    <div class="d-flex topbar align-items-center d-lg-none ms-n2 me-3" title="Show aside menu">
                        <div
                            class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                            id="kt_header_menu_mobile_toggle"
                        >
                            <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                            <span class="svg-icon svg-icon-2x">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                                        fill="black"
                                    ></path>
                                    <path
                                        opacity="0.3"
                                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                                        fill="black"
                                    ></path>
                                </svg>
                            </span>
                            <!--end::Svg Icon-->
                        </div>
                    </div>
                    <!--end::Heaeder menu toggle-->
                    <!--begin::Header Logo-->
                    <theme2-brand class="header-logo me-5 me-md-10 flex-grow-1 flex-lg-grow-0"></theme2-brand>
                    <!--end::Header Logo-->
                    <!--begin::Wrapper-->
                    <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
                        <!--begin::Navbar-->
                        <div class="d-flex align-items-stretch" id="kt_header_nav">
                            <div
                                class="header-menu align-items-stretch"
                                data-kt-drawer="true"
                                data-kt-drawer-name="header-menu"
                                data-kt-drawer-activate="{default: true, lg: false}"
                                data-kt-drawer-overlay="true"
                                data-kt-drawer-width="{default:'200px', '300px': '250px'}"
                                data-kt-drawer-direction="start"
                                data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
                                data-kt-swapper="true"
                                data-kt-swapper-mode="prepend"
                                data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
                            >
                                <top-bar-menu class="w-100"></top-bar-menu>
                            </div>
                        </div>
                        <!--end::Navbar-->
                        <!--begin::Topbar-->
                        <div class="d-flex align-items-stretch flex-shrink-0">
                            <!--begin::Toolbar wrapper-->
                            <div class="topbar d-flex align-items-stretch flex-shrink-0">
                                <active-delegated-users-combo
                                    [customStyle]="'btn btn-hover-transparent-white btn-dropdown btn-lg me-1'"
                                ></active-delegated-users-combo>
                                <subscription-notification-bar
                                    [customStyle]="'btn btn-icon btn-hover-transparent-white btn-dropdown position-relative btn-lg me-1'"
                                ></subscription-notification-bar>
                                <quick-theme-selection
                                    [customStyle]="'btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg me-1'"
                                ></quick-theme-selection>

                                <language-switch-dropdown
                                    [customStyle]="'btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg me-1'"
                                ></language-switch-dropdown>

                                <header-notifications
                                    [customStyle]="'btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg position-relative me-1'"
                                ></header-notifications>

                                <chat-toggle-button
                                    [customStyle]="'btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg position-relative me-1'"
                                ></chat-toggle-button>

                                <user-menu
                                    [iconOnly]="true"
                                    [togglerCssClass]="'btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg'"
                                ></user-menu>
                            </div>
                            <!--end::Toolbar wrapper-->
                        </div>
                        <!--end::Topbar-->
                    </div>
                    <!--end::Wrapper-->
                </div>
                <!--end::Container-->
            </div>
            <!--end::Header-->

            <!--begin::Container-->
            <div class="content flex-row-fluid" id="kt_content">
                <router-outlet></router-outlet>
            </div>
            <!--end::Container-->

            <!--begin::Footer-->
            <footer-bar></footer-bar>
            <!--end::Footer-->
        </div>
        <!--end::Wrapper-->
    </div>
    <!--end::Page-->
</div>
